import { SoftwareService } from '../software-services/software-service';
import { User } from '../user/user';
import { Website } from './website';

export class Client {
	id: number;
	name: string;
	industry: number;
	location: string;
	websites: Website[] = [];
	serviceRep: User;
  isMatrixTools: boolean;

  softwareServiceRenewalDate: Date;
  isSoftwareServiceRenewalDue: boolean;
  isSoftwareServiceRenewalSoon: boolean;

  isWebsiteEnabled: boolean;
  isSeoEnabled: boolean;
  isSmmEnabled: boolean;

  softwareServiceIdList: string;
	softwareServices: SoftwareService[] = [];
}
